<div style="display:table; height: 42px;" *ngIf="details?.type=='dd-group'" class="clearfix float-end mr-2 col-lg-4">
  <nalco-dropdown style="display:table-cell" *ngFor="let ddData of details.data" [ddData]="ddData"
    (ddChange)="ddChangeInSubheader($event)" [dropdownClassName]="ddData.className"></nalco-dropdown>
</div>
<div style="column-gap: 35px; margin-right: 20px;" class="float-end btn-grp mr-2 mt-2" *ngIf="details?.type == 'btn'">
  <div *ngFor="let detail of details.data">
    <a class="{{detail.class}} text-decoration-none" (click)="btnClickInSubhead(detail.value)">{{detail.text}}</a>
  </div>
</div>
@if(rightTemplate()){
  <div class="float-end me-3 d-flex align-items-center" style="height: 42px;">
    <ng-container [ngTemplateOutlet]="rightTemplate()"></ng-container>
  </div>
}